import React from 'react'
import ReactApexChart from 'react-apexcharts'

class ChartBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      series: [
        {
          name: [this.props.name],
          data: [
            this.props.data.Jan,
            this.props.data.Feb,
            this.props.data.Mar,
            this.props.data.Apr,
            this.props.data.May,
            this.props.data.Jun,
            this.props.data.Jul,
            this.props.data.Aug,
            this.props.data.Sep,
            this.props.data.Oct,
            this.props.data.Nov,
            this.props.data.Dec,
          ],
        }
      ],
      options: {
        chart: {
          type: 'bar',
          height: 250,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          borderColor: 'transparent',
        },
        legend: {
          show: true,
          fontSize: '12px',
          fontWeight: 300,

          labels: {
            colors: 'black',
          },
          position: 'bottom',
          horizontalAlign: 'center',
          markers: {
            width: 19,
            height: 19,
            strokeWidth: 0,
            radius: 19,
            strokeColor: '#fff',
            fillColors: ['#8743DF', '#2BC155'],
            offsetX: 0,
            offsetY: 0,
          },
        },
        yaxis: {
          show: false,
        },
        stroke: {
          show: true,
          width: 5,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          labels: {
            style: {
              colors: '#808080',
              fontSize: '14px',
              fontFamily: 'Poppins',
              fontWeight: 100,
            },
          },
        },
        colors: this.props.color,
        fill: {
          colors: this.props.color,
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            },
          },
        },
        responsive: [
          {
            breakpoint: 575,
            options: {
              xaxis: {
                labels: {
                  style: {
                    fontSize: '9px',
                  },
                },
              },
            },
          },
        ],
      },
    }
  }

  render() {
    return (
      <div id='chartBar'>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type='bar'
          height={250}
        />
      </div>
    )
  }
}

export default ChartBar;